import { useState } from "react";
import { FiChevronDown } from "react-icons/fi";
import { FiX, FiMenu } from "react-icons/fi";
import { Link } from "react-router-dom";

import Logo from "../../assets/UNGEGN.png";

export default function Navbar() {
  const [openMobile, setOpenMobile] = useState(false);
  const [openSignIn, setOpenSignIn] = useState(false);

  return (
    <nav className="sticky top-0 z-50 bg-white border-b shadow-sm text-blue-600">
      <div className="max-w-7xl mx-auto px-4 flex items-center justify-between h-16">
        {/* LEFT: Logo */}
        <div className="flex items-center space-x-3">
          <a
            href="/"
            className="flex items-center space-x-3 hover:no-underline"
          >
            <img src={Logo} alt="UNGEGN" className="h-10 w-auto" />
            <p className="font-bold">&nbsp;UNGEGN ASED</p>
          </a>{" "}
          &nbsp;
          <button
            onClick={() => setOpenMobile(!openMobile)}
            className="lg:hidden p-2"
          >
            {openMobile ? (
              <FiX className="w-7 h-7" />
            ) : (
              <FiMenu className="w-7 h-7" />
            )}
          </button>
        </div>

        {/* DESKTOP MENU */}
        <div className="hidden lg:flex space-x-6 text-[15px] font-medium overflow-visible">
          <Link to="/" className="mx-4 py-2 hover:text-blue-600 transition">
            Home
          </Link>

          {/* ABOUT */}
          <div className="relative group overflow-visible mx-4">
            <button className="flex items-center py-2 hover:text-blue-600 transition-colors">
              About &nbsp;
              <FiChevronDown className="ml-1 w-4 h-4 transition-transform group-hover:rotate-180" />
            </button>

            <div
              className="absolute top-full left-0 bg-white shadow-lg rounded-md py-2 w-48 
                border border-gray-200 z-50
                hidden group-hover:block"
            >
              {" "}
              <Link
                to="/aboutased"
                className="block px-4 py-2 hover:bg-blue-50"
              >
                About UNGEGN ASED
              </Link>
              <Link
                to="/chairmanship"
                className="block px-4 py-2 hover:bg-blue-50"
              >
                Chairmanship
              </Link>
              {/* <a href="/chrmsg" className="block px-4 py-2 hover:bg-blue-50">
                Chairman Messages
              </a> */}
              <a href="/workplan" className="block px-4 py-2 hover:bg-blue-50">
                Workplan
              </a>
            </div>
          </div>

          <a
            href="/members"
            className="mx-4 py-2 hover:text-blue-600 transition"
          >
            Members
          </a>

          {/* EVENTS */}
          <div className="relative group overflow-visible mx-4">
            <button className="flex items-center py-2 hover:text-blue-600 transition-colors">
              Events &nbsp;
              <FiChevronDown className="ml-1 w-4 h-4 transition-transform group-hover:rotate-180" />
            </button>

            <div
              className="absolute top-full left-0 bg-white shadow-lg rounded-md py-2 w-48 
              border border-gray-200 z-50
              hidden group-hover:block"
            >
              <Link
                to="/events"
                className="block px-4 py-2 hover:bg-blue-50 text-sm"
              >
                Events
              </Link>
              <Link
                to="/meetings"
                className="block px-4 py-2 hover:bg-blue-50 text-sm"
              >
                Meetings
              </Link>
            </div>
          </div>

          <Link
            to="/gallery"
            className="mx-4 py-2 hover:text-blue-600 transition"
          >
            Gallery
          </Link>
          <Link
            to="/links"
            className="mx-4 py-2 hover:text-blue-600 transition"
          >
            Links
          </Link>
          <Link
            to="/publications"
            className="mx-4 py-2 hover:text-blue-600 transition"
          >
            Publications
          </Link>
        </div>

        {/* RIGHT */}
        <div className="hidden lg:flex items-center space-x-3 overflow-visible relative">
          <button
            onClick={() => setOpenSignIn(!openSignIn)}
            className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition"
          >
            Sign In
            <FiChevronDown className="ml-4 w-4 h-4" />
          </button>

          {openSignIn && (
            <div
              className="absolute top-full right-0 mt-2 bg-white shadow-lg rounded-md py-2 w-44 
              border border-gray-200 z-50"
            >
              <a href="/contributor" className="block px-4 py-2 hover:bg-blue-50">
                Manage Content
              </a>
              <a href="/login-admin" className="block px-4 py-2 hover:bg-blue-50">
                Manage User
              </a>
            </div>
          )}
        </div>
      </div>

      {/* MOBILE MENU */}
      {openMobile && (
        <div className="lg:hidden px-4 pb-4 space-y-2 bg-white border-t animate-fadeIn">
          <Link
            to="/"
            className="block py-3 border-b hover:bg-gray-50 px-2 rounded"
          >
            Home
          </Link>

          {/* ABOUT MOBILE */}
          <div className="border-b">
            <button
              className="w-full text-left py-3 px-2 font-medium flex justify-between items-center hover:bg-gray-50 rounded"
              onClick={() => {
                const aboutContent = document.getElementById("mobile-about");
                aboutContent?.classList.toggle("hidden");
              }}
            >
              About &nbsp;
              <FiChevronDown className="transform transition-transform" />
            </button>
            <div id="mobile-about" className="hidden pl-4 space-y-2 pb-2">
              <Link
                to="/aboutased"
                className="block py-2 hover:bg-gray-50 px-2 rounded"
              >
                About UNGEGN ASED
              </Link>
              <Link
                to="/chairmanship"
                className="block py-2 hover:bg-gray-50 px-2 rounded"
              >
                Chairmanship
              </Link>
              {/* <Link
                to="/chrmsg"
                className="block py-2 hover:bg-gray-50 px-2 rounded"
              >
                Chairman Messages
              </Link> */}
              <Link
                to="/workplan"
                className="block py-2 hover:bg-gray-50 px-2 rounded"
              >
                Workplan
              </Link>
            </div>
          </div>

          <a
            href="/members"
            className="block py-3 border-b hover:bg-gray-50 px-2 rounded"
          >
            Members
          </a>

          {/* EVENTS MOBILE */}
          <div className="border-b">
            <button
              className="w-full text-left py-3 px-2 font-medium flex justify-between items-center hover:bg-gray-50 rounded"
              onClick={() => {
                const eventsContent = document.getElementById("mobile-events");
                eventsContent?.classList.toggle("hidden");
              }}
            >
              Events &nbsp;
              <FiChevronDown className="transform transition-transform" />
            </button>
            <div id="mobile-events" className="hidden pl-4 space-y-2 pb-2">
              <Link
                to="/events"
                className="block py-2 hover:bg-gray-50 px-2 rounded"
              >
                Events
              </Link>
              <Link
                to="/meetings"
                className="block py-2 hover:bg-gray-50 px-2 rounded"
              >
                Meetings
              </Link>
            </div>
          </div>

          <a
            href="/gallery"
            className="block py-3 border-b hover:bg-gray-50 px-2 rounded"
          >
            Gallery
          </a>
          <a
            href="/links"
            className="block py-3 border-b hover:bg-gray-50 px-2 rounded"
          >
            Links
          </a>
          <a
            href="/publications"
            className="block py-3 border-b hover:bg-gray-50 px-2 rounded"
          >
            Publications
          </a>

          <button
            onClick={() => setOpenSignIn(!openSignIn)}
            className="w-full flex items-center justify-center mt-2 px-4 py-3 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition"
          >
            Sign In
            <FiChevronDown className="ml-4 w-4 h-4" />
          </button>

          {openSignIn && (
            <div className="border border-gray-200 rounded-md py-2">
              <a
                href="/contributor"
                className="block py-2 hover:bg-gray-50 px-4 rounded"
              >
                Manage Content
              </a>
              <a
                href="/login-admin"
                className="block py-2 hover:bg-gray-50 px-4 rounded"
              >
                Manage User
              </a>
            </div>
          )}
        </div>
      )}
    </nav>
  );
}
